import React from 'react'
import "../components/pages/Services.css"
import Button from './Button'

function Hero({title,title_s,description, details, btnTitle, link}) {
  return (
    <section className='hero-section'>
    <div className='hero'>
    <h1>{title} <span>{title_s}</span></h1>
    <p>{description}</p>
    <div className='info'>
        {details.map((detail,index) => {
            return <div key={index} className='info-detail'>
            <p className='detail-desc'>{detail.desc}</p>
            <p>{detail.title}</p>
        </div>
        })}
      
    </div>
    <div className='btn'>
    <Button btnTitle={btnTitle} link={link}/>
    </div>
    </div>

</section>
)
}

export default Hero